import { el, svg } from "redom";
const { fetch } = window;

export default class Icon {
  constructor(name = "", opts = {}) {
    const filled = name.includes("-filled");
    this.use = svg("use", { href: `#ti-${name}` });
    this.el = el(
      ".icon",
      opts,
      svg(
        "svg",
        {
          viewBox: "0 0 24 24",
          fill: filled ? "currentColor" : "none",
          stroke: filled ? "none" : "currentColor",
          style: {
            width: "1em",
            height: "1em",
          },
        },
        this.use
      )
    );
  }
  update(name) {
    const filled = name.includes("-filled");
    this.use.setAttribute("href", `#ti-${name}`);
    this.use.setAttribute("fill", filled ? "currentColor" : "none");
    this.use.setAttribute("stroke", filled ? "none" : "currentColor");
  }
}

const defs = svg("defs");

document.body.appendChild(svg("svg", { style: { display: "none" } }, defs));

const { staticPath } = window;

for (const style of ["outline", "filled"]) {
  getIcons(style);
}

async function getIcons(style) {
  try {
    const json = await fetch(
      `${staticPath}tabler/svg/tabler-nodes-${style}.json`
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res;
      })
      .then((res) => res.json());

    for (const name in json) {
      const icon = json[name];
      const filled = style === "filled";
      const id = `ti-${name}${filled ? "-filled" : ""}`;

      defs.appendChild(
        svg(
          "symbol",
          {
            id,
            viewBox: "0 0 24 24",
          },

          icon.map((data) => {
            return svg(data[0], data[1]);
          })
        )
      );
    }
  } catch (err) {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    getIcons(style);
  }
}
